import { isProduction } from "@faire/web--source/common/user-agent/isProduction";

type Environment = "production" | "staging";

export const useEnvironment = (): Environment => {
  if (isProduction()) {
    return "production";
  }
  return "staging";
};
